import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sx/Support.webp")